import styled from 'styled-components';
import { COLORS, pickThemeColor, pickThemeFontStyles } from '@/theme';
import { Button, Drawer } from '@/ui';

export const StyledPageWrapper = styled.div`
  display: flex;
  flex-direction: column;

  &&& .ant-drawer-body {
    padding: 0;
  }
`;

export const StyledPageTitle = styled.div`
  ${pickThemeFontStyles('40', '48', 'SEMI_BOLD')};
  color: ${COLORS.DARK_PURPLE};
`;

export const StyledHeaderBlock = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 2rem 2rem 0 2rem;
`;

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-header-title {
    justify-content: space-between;
    flex-direction: row-reverse;
  }

  .ant-drawer-title {
    padding: 0.5rem;
    ${pickThemeFontStyles('28', '32', 'SEMI_BOLD')};
    color: ${pickThemeColor('BLACK_PRIMARY')};

    span {
      text-transform: capitalize;
    }
  }

  .ant-drawer-header {
    border: none;
  }

  .ant-drawer-close {
    margin: 0;
  }

  &&& .ant-drawer-body {
    padding: 0;
  }

  .ant-drawer-title {
    flex-direction: row-reverse;
  }
`;

export const StyledContentBlock = styled.div`
  display: flex;
  width: 100%;
  padding: 2rem;
  flex-direction: column;
`;

export const StyledButton = styled(Button)`
  svg {
    margin-right: 0.5rem;
  }
`;
